import PropTypes from 'prop-types';

export const eventPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  slug: PropTypes.string,
  dateMode: PropTypes.string,
  eventDates: PropTypes.arrayOf(PropTypes.string),
  timeMode: PropTypes.string,
  times: PropTypes.arrayOf(PropTypes.string),
  allowedSizes: PropTypes.arrayOf(PropTypes.string),
  descriptionHTML: PropTypes.string,
  mode: PropTypes.string,
  hasWaitlist: PropTypes.bool,
});

export const eventKeys = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  dateMode: 'dateMode',
  eventDates: 'eventDates',
  timeMode: 'timeMode',
  times: 'times',
  allowedSizes: 'allowedSizes',
  descriptionHTML: 'descriptionHTML',
  mode: 'mode',
  hasWaitlist: 'hasWaitlist',
};
